<template>
  <v-dialog v-model="permissionsDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="submit()">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-id-card-alt</v-icon>
              <span class="px-3">{{ $t(`Edit Staff Member's permissions`) }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs6 pb-3>
              <div class="caption no-select">{{ $t('Staff Member') }}</div>
              <strong>{{ staffMemberInfo.user_full_name || '-' }}</strong>
            </v-flex>

            <v-flex xs12>
              <v-text-field
                v-model="search"
                label="Search Permissions"
                box
                hide-details
                background-color="white"
                clearable
                clear-icon="mdi-close"
              />
            </v-flex>

            <v-flex xs12 pl-4 pr-4>
              <v-checkbox v-model="grandAll" color="indigo">
                <template v-slot:label>
                  <strong class="grey--text text--darken-3">{{ $t('Grand All') }}</strong>
                </template>
              </v-checkbox>
            </v-flex>

            <v-flex xs12 v-if="!grandAll">
              <v-treeview
                v-model="tree"
                :items="items"
                activatable
                active-class="grey lighten-4 indigo--text"
                selected-color="indigo"
                selectable
                open-on-click
                :open.sync="open"
                :search="search"
                :filter="filter"
                expand-icon="mdi-chevron-down"
              >
                <template v-slot:label="{ item }">{{ $t(item.name.trim()) }}</template>
              </v-treeview>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout justify-start>
            <v-btn flat @click="tree = getAllPermissionsTree()">Reset</v-btn>
          </v-layout>
          <v-layout justify-end>
            <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
            <v-btn type="submit" color="success" :loading="btnUpdateLoading">
              <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
              {{ $t('Update Permissions') }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'staff-member-permissions',

  props: {
    permissionsDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false,
      grandAll: false,
      tree: [],
      items: [],
      open: [],
      search: null
    }
  },

  computed: {
    ...mapGetters({
      staffMemberInfo: 'staff/getStaffMemberInfo',
      allPermissionsList: 'staff/getAllPermissionsList'
    }),

    filter() {
      return this.caseSensitive ? (item, search, textKey) => item[textKey].indexOf(search) > -1 : undefined
    }
  },

  mounted() {
    this.fetchAllPermissions()
  },

  watch: {
    permissionsDialog: {
      immediate: false,
      handler() {
        if (this.permissionsDialog) {
          this.addEscKeyListener()
          this.items = this.allPermissionsList
          this.tree = this.getAllPermissionsTree()
          this.open = []
          this.grandAll = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      fetchAllPermissions: 'staff/fetchAllPermissions',
      assignPermissions: 'staff/assignPermissions'
    }),

    getAllPermissionsTree() {
      let actions = this.staffMemberInfo.actions_permissions
      let sidebars = this.staffMemberInfo.sidebar_permissions.filter(
        item => item === 58 || (item !== 80 && item >= 69 && item <= 88)
      )
      actions.push(...sidebars)
      return actions
    },

    getParents(children) {
      let parents = []

      const parentsOfChildren = [
        { from: 1000, to: 1009, parents: [1, 8, 31] },
        { from: 1010, to: 1020, parents: [1, 8, 32] },
        { from: 1021, to: 1030, parents: [1, 8, 33] },
        { from: 1031, to: 1036, parents: [1, 8, 34] },
        { from: 1041, to: 1044, parents: [1, 9, 35] },
        { from: 1037, to: 1040, parents: [1, 9, 36] },
        { from: 1253, to: 1256, parents: [1, 9, 92] },
        { from: 1049, to: 1052, parents: [1, 10, 37] },
        { from: 1045, to: 1048, parents: [1, 10, 38] },
        { from: 1053, to: 1058, parents: [1, 11, 39] },
        { from: 1059, to: 1064, parents: [1, 11, 40] },
        { from: 1065, to: 1068, parents: [1, 11, 41] },
        { from: 1069, to: 1073, parents: [1, 11, 42] },
        { from: 1238, to: 1241, parents: [1, 11, 89] },
        { from: 1074, to: 1079, parents: [1, 12, 43] },
        { from: 1086, to: 1091, parents: [1, 12, 44] },
        { from: 1243, to: 1247, parents: [1, 12, 90] },
        { from: 1098, to: 1105, parents: [1, 13, 45] },
        { from: 1236, to: 1236, parents: [1, 13, 45] },
        { from: 1106, to: 1108, parents: [1, 13, 46] },
        { from: 1109, to: 1116, parents: [1, 13, 47] },
        { from: 1117, to: 1124, parents: [1, 13, 48] },
        { from: 1249, to: 1252, parents: [1, 13, 91] },
        { from: 1125, to: 1128, parents: [1, 14, 49] },
        { from: 1129, to: 1134, parents: [1, 14, 50] },
        { from: 1135, to: 1138, parents: [1, 15, 51] },
        { from: 1139, to: 1142, parents: [1, 15, 52] },
        { from: 1080, to: 1085, parents: [1, 16, 53] },
        { from: 1092, to: 1097, parents: [1, 16, 54] },
        { from: 1143, to: 1143, parents: [2, 17, 55] },
        { from: 1149, to: 1154, parents: [2, 17, 56] },
        { from: 1144, to: 1148, parents: [2, 17, 57] },
        { from: 58, to: 58, parents: [2, 17] },
        { from: 1155, to: 1159, parents: [2, 17, 59] },
        { from: 1237, to: 1237, parents: [2, 17, 59] },
        { from: 1164, to: 1167, parents: [2, 18, 60] },
        { from: 1242, to: 1242, parents: [2, 18, 60] },
        { from: 1160, to: 1163, parents: [2, 18, 61] },
        { from: 1172, to: 1175, parents: [2, 19, 62] },
        { from: 1168, to: 1171, parents: [2, 19, 63] },
        { from: 1176, to: 1179, parents: [2, 20, 64] },
        { from: 1180, to: 1185, parents: [2, 20, 65] },
        { from: 1186, to: 1189, parents: [2, 20, 66] },
        { from: 1190, to: 1193, parents: [2, 20, 67] },
        { from: 1248, to: 1248, parents: [2, 20, 67] },
        { from: 1194, to: 1197, parents: [2, 20, 68] },
        { from: 69, to: 73, parents: [3, 21] },
        { from: 74, to: 79, parents: [3, 22] },
        { from: 1198, to: 1199, parents: [3, 23, 80] },
        { from: 81, to: 87, parents: [3, 23] },
        { from: 1225, to: 1228, parents: [4] },
        { from: 1221, to: 1224, parents: [5, 24] },
        { from: 1217, to: 1220, parents: [5, 25] },
        { from: 1200, to: 1211, parents: [6, 26] },
        { from: 1212, to: 1215, parents: [6, 27] },
        { from: 1216, to: 1216, parents: [6, 28] },
        { from: 1229, to: 1230, parents: [7, 29] },
        { from: 88, to: 88, parents: [7] },
        { from: 1231, to: 1235, parents: [7, 30] }
      ]

      for (let index = 0; index < children.length; index++) {
        const newParents = parentsOfChildren
          .filter(item => item.from <= children[index] && item.to >= children[index])
          .map(item => item.parents)[0]

        if (newParents !== undefined) {
          parents.push(...newParents)
        }
      }

      return [...new Set(parents)]
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.permissionsDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    submit() {
      this.btnUpdateLoading = true

      let formData = new FormData()
      if (this.grandAll) {
        formData.append('all', 'all')
      } else {
        const children = this.tree.filter(item => item >= 1000)
        const oldParents = this.tree.filter(item => item < 1000)
        const newParents = this.getParents(this.tree)
        let parents = []

        if (oldParents === []) {
          parents.push(...newParents)
        } else if (newParents === []) {
          parents.push(...oldParents)
        } else {
          parents.push(...oldParents)
          parents.push(...newParents)
          parents = [...new Set(parents)]
        }

        children.forEach((p, index) => {
          formData.append('permission_id[' + [index] + ']', p)
        })

        parents.forEach((p, index) => {
          formData.append('sidebar_id[' + [index] + ']', p)
        })
      }

      let payload = { id: this.staffMemberInfo.user_id, formData }

      this.assignPermissions(payload)
        .then(() => {
          this.btnUpdateLoading = false
          this.$emit('hidemodal')
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped />
